module.exports = __webpack_public_path__ + "static/media/logo_white.cecbe0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_white.png
// module id = 60
// module chunks = 0